import { render, staticRenderFns } from "./app-filter.vue?vue&type=template&id=671efd68"
import script from "./app-filter.vue?vue&type=script&lang=js"
export * from "./app-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports